import { assetUrl } from "@/lib/api";
import { PROFILES } from "@/lib/demo/companies";

const IMG_SIZE = { "text-lg": "h-7 max-w-[140px]", "text-xl": "h-8 max-w-[160px]", "text-3xl": "h-16 max-w-[200px]" };

export const CompanyLogo = ({ id, logo, size = "text-2xl", className = "" }) => {
  const { text, color, cls, dot, mark, img } = logo || PROFILES[id].logo;
  if (img) return <img src={assetUrl(img)} alt="" className={`${IMG_SIZE[size] || "h-10 max-w-[160px]"} w-auto object-contain ${className}`} data-testid={`company-logo-${id}`} />;
  return (
    <span className={`inline-flex items-baseline font-display ${size} ${cls} ${className}`} style={{ color }} data-testid={`company-logo-${id}`}>
      {text}
      {dot && <span className="ml-0.5 inline-block h-[0.28em] w-[0.28em] rounded-full" style={{ background: dot }} />}
      {mark && <span className="ml-1 text-[0.8em]">{mark}</span>}
    </span>
  );
};
